import { render, staticRenderFns } from "./WorkflowGuide.vue?vue&type=template&id=522f2cbc"
import script from "./WorkflowGuide.vue?vue&type=script&lang=js"
export * from "./WorkflowGuide.vue?vue&type=script&lang=js"
import style0 from "./WorkflowGuide.vue?vue&type=style&index=0&id=522f2cbc&prod&lang=scss"
import style1 from "./WorkflowGuide.vue?vue&type=style&index=1&id=522f2cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports